import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { GlobalProperties } from '@shared/models/classes/GlobalProperties';
import { ButtonComponent } from '../button/button.component';
import { TextHeaderComponent } from '../text-header/text-header.component';
import { TextComponent } from '../text/text.component';
@Component({
  standalone: true,
  selector: 'section-5',
  imports: [TextHeaderComponent, TextComponent, ButtonComponent],
  templateUrl: './section-5.component.html',
  styleUrls: ['../section.scss', './section-5.component.scss'],
})
export class Section5Component extends GlobalProperties {
  constructor(private _router: Router) {
    super();
  }

  onRead() {
    this._router.navigateByUrl(this.ROUTES.BLOG.value);
  }
}
